import { Box, Button, Chip, Container, Stack, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useNavigate } from 'react-router-dom';
import Logo from '../../Components/Logo';
import { brandPanelGradient, ON_DARK, scrollToSection } from './constants';

const Hero = () => {
	const navigate = useNavigate();

	return (
		<Box
			component="section"
			sx={{
				position: 'relative',
				minHeight: { xs: '88vh', md: '92vh' },
				display: 'flex',
				alignItems: 'center',
				background: (theme) => brandPanelGradient(theme.palette.mode),
			}}
		>
			<Container
				maxWidth="md"
				sx={{ py: { xs: 8, md: 10 }, textAlign: 'center' }}
			>
				<Chip
					label="30-day free trial · No credit card · $25/mo"
					sx={{
						mb: 3,
						bgcolor: 'rgba(245, 158, 11, 0.15)',
						color: 'warning.main',
						border: '1px solid',
						borderColor: 'warning.main',
						fontWeight: 600,
					}}
				/>
				<Logo
					variant="onDark"
					sx={{
						width: { xs: 220, sm: 280, md: 320 },
						height: 'auto',
						mb: 3,
						mx: 'auto',
						display: 'block',
						filter: 'drop-shadow(0 4px 16px rgba(0, 0, 0, 0.35))',
					}}
				/>
				<Typography
					variant="h4"
					component="h1"
					sx={{
						color: ON_DARK.text,
						fontWeight: 700,
						mb: 2,
						fontSize: { xs: '1.85rem', sm: '2.35rem', md: '2.65rem' },
						lineHeight: 1.2,
					}}
				>
					Send the proposal. Bidzbase follows up until they say yes or no.
				</Typography>
				<Typography
					variant="body1"
					sx={{
						color: ON_DARK.muted,
						maxWidth: 640,
						mx: 'auto',
						mb: 4,
						lineHeight: 1.75,
						fontSize: { xs: '1rem', sm: '1.125rem' },
					}}
				>
					One-click accept in the email. Automatic reminders on open bids and
					unpaid invoices. Deposit when they say yes. The full bid-to-invoice
					loop — not another field-service suite.
				</Typography>
				<Stack
					direction={{ xs: 'column', sm: 'row' }}
					spacing={2}
					justifyContent="center"
					alignItems="center"
				>
					<Button
						variant="contained"
						size="large"
						color="warning"
						startIcon={<RocketLaunchIcon />}
						onClick={() => navigate('/signup')}
						sx={{ px: 4, py: 1.5, fontSize: '1rem' }}
					>
						Start free trial
					</Button>
					<Button
						variant="outlined"
						size="large"
						startIcon={<EmailIcon />}
						onClick={() => scrollToSection('sample-demo')}
						sx={{
							px: 4,
							py: 1.5,
							fontSize: '1rem',
							color: ON_DARK.text,
							borderColor: ON_DARK.soft,
							'&:hover': {
								borderColor: 'warning.main',
								color: 'warning.main',
								bgcolor: 'rgba(245, 158, 11, 0.08)',
							},
						}}
					>
						See a sample proposal
					</Button>
					<Button
						variant="text"
						size="large"
						onClick={() => scrollToSection('follow-ups')}
						sx={{
							px: 4,
							py: 1.5,
							fontSize: '1rem',
							color: ON_DARK.soft,
						}}
					>
						How follow-ups work
					</Button>
				</Stack>
			</Container>
		</Box>
	);
};

export default Hero;
